import * as Model from '../../model/types';
import {Hasher, MemoizedHasher} from '../../hash';
import {ForwardGraphStorage} from './types';
import {ForwardOp} from '.';

export class HashingStorage implements ForwardGraphStorage {
  private hash: Hasher;
  private roots = new Set<ForwardOp>();
  private ops = new Map<string, ForwardOp>();

  public constructor() {
    this.hash = new MemoizedHasher();
  }

  getRoots(): Set<ForwardOp> {
    return this.roots;
  }

  getOp(op: Model.Op): ForwardOp | undefined {
    return this.ops.get(this.hash.opId(op));
  }

  setOp(op: ForwardOp) {
    this.ops.set(this.hash.opId(op.op), op);
  }
}
